<template lang="html">
	<div
	id="engagement"
	data-sal="slide-up"
	data-sal-duration="2000"
	data-sal-easing="ease-out-back"
	class="section1-container">
		<h1>Organic Engagement</h1>
		<div class="img-gallery">
			<img src="@/assets/img/engagement/9.png">
			<img src="@/assets/img/engagement/10.png">
			<img src="@/assets/img/engagement/11.png">
			<img src="@/assets/img/engagement/12.png">
			<img src="@/assets/img/engagement/13.png">
			<img src="@/assets/img/engagement/14.png">
			<img src="@/assets/img/engagement/5.png">
			<img src="@/assets/img/engagement/6.png">
			<img src="@/assets/img/engagement/7.png">
			<img src="@/assets/img/engagement/8.png">
			<img src="@/assets/img/engagement/4.png">
			<img src="@/assets/img/engagement/1.png">
			<img src="@/assets/img/engagement/2.png">
		</div>
	</div>
</template>

<script>
import sal from "sal.js"; // No need to use in main.js file

export default {
		mounted() {
				sal();
		},
}
</script>

<style scoped lang="scss">
.section1-container {
	width: 80%;
	max-width: 800px;
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	h1 {
		padding-top:50px;
		font-size:40px;
		color: black;
		font-weight: 800;
		font-size: 3rem;
		font-family: ITCSouvenirBold;
		z-index: 1000;
		text-decoration: underline;
		text-decoration-color: $main-2;
	}
	.img-gallery{
		display: flex;
		flex-direction: column;
		flex-flow:wrap;
		justify-content: center;
		align-items: center;
	}
	img {
		margin: 15px;
		width:45%;
		height: auto;
		@media only screen and (max-width: $screen-portrait-retina-max)  {
			width: 80%;
		}
	}
}
		
</style>